import React, {useState, useEffect} from "react";
import "../GlobalStyles.css";
import "./CongratsPage.css";
import Loader from "../Loader/Loader";
import GoogleAnalytics from "../../analytics/GoogleAnalytics";
import AwsApiService from "../../services/AwsApiService";
import ContestService from "../../services/ContestService";
import {useLoading} from "../../context/LoadingContext";
import {useAuth} from "../../context/AuthContext";
import {useAccount} from "../../context/AccountContext";
import useTheme from "../../Themes/ThemeProvider.ts";
import {useTranslation} from "react-i18next";
import jwtDecode from "jwt-decode";
import UserService from "../../services/UserService";
import AddonComponent from "./components/AddonComponent/AddonComponent";
import AddonSuccessComponent from "./components/AddonSuccessComponent/AddonSuccessComponent";

function CongratsPage() {
    let account = useAccount();
    const theme = useTheme();

    const {setCheckLoggedIn} = useAuth();

    const [contest, setContest] = useState();

    const [buttonRedirect, setButtonRedirect] = useState();
    const {t} = useTranslation();

    const [resolveWithIframe, setResolveWithIframe] = useState(false);
    const [resolvingAction, setResolvingAction] = useState();
    const [dynamicLoginConfig, setDynamicLoginConfig] = useState({});
    const [resolveActionUrl, setResolveActionUrl] = useState("");
    const [resolveActionToken, setResolveActionToken] = useState("");

    const [addonMlink, setAddonMlink] = useState();
    const [addonEligible, setAddonEligible] = useState(null);

    const {isLoading, removeLoading} = useLoading()
    const [loadingDelay, setLoadingDelay] = useState(true);

    useEffect(() => { //nothing needs to wait loading to do these actions
        if (
            sessionStorage.getItem("kc_resolve_token") ||
            sessionStorage.getItem("kc_tok")
        ) {
            GoogleAnalytics.onCongratsLoad(account.chosenProgramName);
            GoogleAnalytics.onProductConversion(account.analyticsProductConversion);
            GoogleAnalytics.onEvProductConversion(account.analyticsEvProductConversion);
            GoogleAnalytics.onAddonProductConversion(account.analyticsAddonProductConversion);
            AwsApiService.onWelcome(account.chosenProgramName);
        }

        if (!!sessionStorage.getItem("kc_resolve_token")) {
            //case new user
            setResolvingAction(true)
            let kcAction = JSON.parse(sessionStorage.getItem("kc_action"))
            let actionToken = jwtDecode(kcAction?.token);

            let redirectUri = actionToken?.["redirect_uri"]
            let clientId = actionToken?.azp
            setDynamicLoginConfig({clientId, redirectUri})
            setButtonRedirect(redirectUri);

            let resolveToken = sessionStorage.getItem("kc_resolve_token");
            let actionUrl = new URL(kcAction?.challenge.replace("%7Bchallenge%7D", resolveToken));
            setResolveActionUrl(actionUrl.toString());

            if (redirectUri?.startsWith("http")) {
                setResolveWithIframe(true);
                setTimeout(() => {
                    sessionStorage.removeItem("kc_action");
                    sessionStorage.removeItem("kc_resolve_token");
                }, 2500)
            }
        } else {
            //case existing user
            setButtonRedirect(process.env.REACT_APP_CONGRATS_BUTTON_LINK)
        }

        //both user actions
        if (sessionStorage.getItem("coupon-success")) {
            //case coupon used
            sessionStorage.removeItem("coupon-success");
            setButtonRedirect(process.env.REACT_APP_COUPON_UPGRADE_FREE_REDIRECT)
        }

        if (sessionStorage.getItem("congratsRedirectURL")) {
            //if a promo session is active
            const temp = sessionStorage.getItem("congratsRedirectURL")
            // console.log(temp)
            sessionStorage.removeItem("congratsRedirectURL")
            setButtonRedirect(temp)
        } else if (sessionStorage.getItem("contestSession")) {
            //if a contest session is active
            setContest(sessionStorage.getItem("contestSession"))
            ContestService.entryContest({contestId: sessionStorage.getItem("contestSession")})
                .then(response => {
                })
                .catch(error => {
                    console.error(error);
                })
            setButtonRedirect(sessionStorage.getItem("contestRedirectURL"))
            sessionStorage.removeItem("contestSession");
            sessionStorage.removeItem("isContestUpgrade")
            sessionStorage.removeItem("contestRedirectURL")
        }

        if(sessionStorage.getItem("addon-mlink")){
            setAddonMlink(JSON.parse(sessionStorage.getItem("addon-mlink")))
            console.log(sessionStorage.getItem("addon-mlink"))
            sessionStorage.removeItem("addon-mlink")
        }
        if(sessionStorage.getItem("addon-eligible")){
            setAddonEligible(JSON.parse(sessionStorage.getItem("addon-eligible")))
            sessionStorage.removeItem("addon-eligible")
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {//this page is not interestead in loading, if we are here we are here.
        if (isLoading("INIT")) {
            removeLoading("INIT")
        }
        // eslint-disable-next-line
    }, [isLoading]);


    useEffect(() => {
        setTimeout(() => {
            setLoadingDelay(false);
        }, 2000)
    }, []);

    const onStart = () => {
        setCheckLoggedIn(false);
        if (resolvingAction && resolveWithIframe) {
            UserService.dynamicLogin(dynamicLoginConfig)
        } else if (resolvingAction && !resolveWithIframe && !!resolveActionUrl) {
            sessionStorage.removeItem("kc_action");
            sessionStorage.removeItem("kc_resolve_token");
            window.location.replace(resolveActionUrl)
        } else {
            window.location.replace(buttonRedirect ?? "/")
        }
    };

    return (
        <>
            {isLoading() ? (
                <Loader/>
            ) : (
                <>
                    {loadingDelay && <Loader/>}
                    <div className={"congrats-container"} style={{opacity: loadingDelay ? 0 : 1}}>
                        <div className={"congrats-upper-wrapper"}>
                            {resolvingAction && resolveWithIframe && resolveActionUrl?.length > 0 &&
                                <iframe hidden={true} title={"resolution-iframe"} src={resolveActionUrl ?? ""}></iframe>}
                            <div className={"congrats-title-container"}>
                                <a href={"/"} className={"congrats-back-to-home"}>
                                    <img src={"images/congrats-page/congratsArrowBack.svg"} alt={"back to homepage"}/>
                                    {t("congratsBackToHome")}
                                </a>

                                <div className={"contestTitle"}>
                                    {(contest && !!sessionStorage.getItem("kc_resolve_token")) ?
                                        t("congratsContestRegisterTitle")
                                        :
                                        contest ?
                                            t("congratsContestTitle")
                                            :
                                            !!sessionStorage.getItem("kc_resolve_token") ?
                                                <p>{t("congratsInfo")}</p>
                                                :
                                                <p>{t("congratsProductChangeTitle")}</p>
                                    }
                                </div>

                            </div>
                            <AddonSuccessComponent addon={addonMlink}/>
                            <AddonComponent addons={addonEligible}/>
                            <theme.congrats.ContentContainerUpper/>
                            {theme.congrats.primaryCTA &&
                                <button className={"congrats-button"} onClick={onStart}>
                                    {t("congratsButtonText")}
                                </button>
                            }
                        </div>
                        <div className={"congrats-content-container-wrapper"}>
                            <div className={"congrats-content-container"}>
                                <theme.congrats.ContentContainerLower/>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default CongratsPage;
